var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhereToVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03853 9.89407L10.2586 5.67397L9.27849 4.69383L6.03853 7.93378L4.7552 6.65045L3.77505 7.6306L6.03853 9.89407ZM7.00103 17.7174C4.69409 15.7184 2.96418 13.8581 1.81132 12.1365C0.658462 10.4147 0.0820312 8.83395 0.0820312 7.39432C0.0820312 5.27896 0.766246 3.5664 2.13468 2.25664C3.50326 0.946874 5.12538 0.291992 7.00103 0.291992C8.87668 0.291992 10.4988 0.946874 11.8674 2.25664C13.2358 3.5664 13.92 5.27896 13.92 7.39432C13.92 8.83395 13.3436 10.4147 12.1907 12.1365C11.0379 13.8581 9.30797 15.7184 7.00103 17.7174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhereToVote);
export default __webpack_public_path__ + "static/media/where_to_vote.964667862a318ae97a4500921c734bb5.svg";
export { ForwardRef as ReactComponent };